class EditorialDragScroll {
  constructor(element) {
    // Ensure we have a valid element
    if (!element) return;
    
    this.element = element;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.velocity = 0;
    this.momentumID = null;
    this.lastX = 0;
    this.timestamp = 0;
    
    // Bind event handlers to preserve 'this' context
    this.startDragging = this.startDragging.bind(this);
    this.stopDragging = this.stopDragging.bind(this);
    this.drag = this.drag.bind(this);
    this.resetDragState = this.resetDragState.bind(this);
    
    // Only initialize on desktop
    if (window.innerWidth >= 991) {
      this.init();
    }
  }
  
  init() {
    try {
      // Add event listeners
      this.element.addEventListener('mousedown', this.startDragging);
      document.addEventListener('mouseup', this.stopDragging); // Listen on document level to catch all mouseup events
      document.addEventListener('mouseleave', this.stopDragging);
      this.element.addEventListener('mousemove', this.drag);
      
      // Emergency reset handler for edge cases
      window.addEventListener('blur', this.resetDragState);
      
      // Prevent default browser drag behaviors
      this.element.addEventListener('dragstart', e => e.preventDefault());
    } catch (error) {
      console.error('Error initializing drag scroll:', error);
    }
  }
  
  // Reset drag state in case something goes wrong
  resetDragState() {
    this.isDown = false;
    this.element.classList.remove('dragging');
    
    if (this.momentumID) {
      cancelAnimationFrame(this.momentumID);
      this.momentumID = null;
    }
  }
  
  startDragging(e) {
    // Ensure only left mouse button triggers drag
    if (e.button !== 0) return;
    
    this.isDown = true;
    this.element.classList.add('dragging');
    this.startX = e.pageX - this.element.offsetLeft;
    this.scrollLeft = this.element.scrollLeft;
    this.timestamp = Date.now();
    this.lastX = e.pageX;
    
    // Clear any existing momentum
    if (this.momentumID) {
      cancelAnimationFrame(this.momentumID);
      this.momentumID = null;
    }
  }
  
  stopDragging(e) {
    if (!this.isDown) return;
    
    this.isDown = false;
    this.element.classList.remove('dragging');
    
    // Calculate velocity for momentum
    const now = Date.now();
    const elapsed = now - this.timestamp;
    
    if (elapsed > 0) {
      this.velocity = (this.element.scrollLeft - this.scrollLeft) / elapsed * 15;
      this.applyMomentum();
    }
  }
  
  drag(e) {
    if (!this.isDown) return;
    e.preventDefault();
    
    const x = e.pageX - this.element.offsetLeft;
    const walk = (x - this.startX) * 1.5; // Multiply for faster scrolling
    this.element.scrollLeft = this.scrollLeft - walk;
    
    // Update last position for velocity calculation
    this.lastX = e.pageX;
  }
  
  applyMomentum() {
    if (Math.abs(this.velocity) < 0.1) {
      this.momentumID = null;
      return;
    }
    
    this.element.scrollLeft += this.velocity;
    this.velocity *= 0.95; // Reduce velocity by friction
    
    this.momentumID = requestAnimationFrame(this.applyMomentum.bind(this));
  }
  
  // Clean up method to remove event listeners if necessary
  destroy() {
    this.element.removeEventListener('mousedown', this.startDragging);
    document.removeEventListener('mouseup', this.stopDragging);
    document.removeEventListener('mouseleave', this.stopDragging);
    this.element.removeEventListener('mousemove', this.drag);
    window.removeEventListener('blur', this.resetDragState);
    
    if (this.momentumID) {
      cancelAnimationFrame(this.momentumID);
      this.momentumID = null;
    }
  }
}

// Initialize drag scroll for all carousel wrappers
document.addEventListener('DOMContentLoaded', () => {
  try {
    const carousels = document.querySelectorAll('[data-drag-carousel]');
    carousels.forEach(carousel => {
      new EditorialDragScroll(carousel);
    });
  } catch (error) {
    console.error('Error initializing editorial drag scroll:', error);
  }
}); 